import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function UpdateDialog({ open, onClose, onRefresh, onRemindLater }) {
  return (
    <Dialog
      open={open}
      aria-labelledby="update-dialog-title"
      aria-describedby="update-dialog-description"
      disableEscapeKeyDown
    >
      <DialogTitle id="update-dialog-title">
        {"Application Update Available"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="update-dialog-description">
          A new version is available. Refresh the page to update. You might lose
          your work - Please save your progress.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onRemindLater} color="primary">
          Remind in 5 minutes
        </Button>
        <Button onClick={onRefresh} color="primary" autoFocus>
          Refresh
        </Button>
      </DialogActions>
    </Dialog>
  );
}

UpdateDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  onRemindLater: PropTypes.func.isRequired,
};

export default UpdateDialog;